// extracted by mini-css-extract-plugin
export default {"root":"src-views-common-components-CommaSeparatedList-CommaSeparatedList__root--VVtjJ"};